/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 26/5/2022 上午 11:10 下午 1:57 🚌🚄🚈🚝 */
<template>
	<div ref="resetRow">
		<vue-drag-resize :x="100" :y="100" :w="300" :h="220" :isDraggable="true" :isActive="true" :isResizable="false" @dragstop="dragstop">
			<div class="wrap">
				<span class="name">行数设置</span>
				<el-form label-width="50px" label-position="left" size="medal" class="form-style">
					<el-row>
						<el-col :span="24">
							<el-form-item label="行数">
								<step @stepVal="stepVal" :defaultVal="4"></step>
							</el-form-item>
						</el-col>
						<el-col :span="24" class="btn-evenly">
							<el-button type="primary" @click="confirmResetRows">确定</el-button>
							<el-button @click="quitSetRows">取消</el-button>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</vue-drag-resize>
	</div>
</template>
<script>
import { cloneDeep, sortBy } from 'lodash'
import VueDragResize from 'vue-drag-resize'
import step from './step'
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'

export default {
	name: 'resetRow',
	components: { VueDragResize, step },
	data() {
		return {
			nums: 4,
			direction: '',
			options: {}
		}
	},
	computed: mapGetters('examination/configation', ['tempObjTopic']),
	methods: {
		//确认
		confirmResetRows() {
			const options = cloneDeep(this.options)
			const appendInfo = JSON.parse(options.appendInfo)
			const remarks = JSON.parse(options.remarks)
			if (this.direction === 'H') {
				this.horizontalResetRow(options, appendInfo, remarks)
			} else if (this.direction === 'V') {
				this.verticalResetRow(options, appendInfo, remarks)
			}
		},
		// 手动配置情况下 竖向行数增加或者减少
		verticalResetRow(options, appendInfo, remarks) {
			if (this.tempObjTopic.length === 0) {
				this.$message.error('请选择可客观题')
				return
			}
			const _this = this
			let box = appendInfo.box
			let title = remarks.title

			if (this.nums > title.length) {
				moreRow(this.nums - title.length)
			} else if (this.nums < title.length) {
				lessRow(this.nums)
			} else {
				return
			}
			//行数增加
			function moreRow(interval) {
				const resultObjTopic = _this.tempObjTopic.reduce((acc, cur) => (acc = [...acc, ...cur.val]), [])
				const orderTitle = orderBy(title, ['y'], ['desc'])
				const lastRow = cloneDeep(box.filter(res => res.n === orderTitle[0].n))
				let rowHeight = 50
				if (title.length > 1) rowHeight = orderTitle[0].y - orderTitle[1].y
				let resTopic = []
				for (let i = 0; i < resultObjTopic.length; i++) {
					if (orderTitle[0].n === resultObjTopic[i].pkId) {
						resTopic = resultObjTopic.slice(i + 1, i + interval + 1)
						break
					}
				}
				let addBox = [],
					addTitle = []
				for (let j = 1; j <= resTopic.length; j++) {
					lastRow.forEach(res => {
						res.y = res.y + rowHeight * j
						res.n = resTopic[j - 1].pkId
						res.m = resTopic[j - 1].bigTopic
					})
					addBox.push(...lastRow)
					const first = cloneDeep(lastRow[0])
					first.v = resTopic[j - 1].smallTopic
					first.x -= 50
					addTitle.push(first)
				}
				const resultBox = [...box, ...addBox]
				const resultTitle = [...title, ...addTitle]
				appendInfo.box = resultBox
				appendInfo.title = resultTitle
				remarks.title = resultTitle
				options.appendInfo = JSON.stringify(appendInfo)
				options.remarks = JSON.stringify(remarks)
				options.boxList = resultBox
				options.boxFromAppendInfo = resultBox
			}
			//行数减少
			function lessRow(nums) {
				title.length = nums
				const nVal = title.map(res => res.n)
				const resultBox = box.filter(res => nVal.includes(res.n))
				appendInfo.box = resultBox
				appendInfo.title = title
				remarks.title = title
				options.appendInfo = JSON.stringify(appendInfo)
				options.remarks = JSON.stringify(remarks)
				options.boxList = resultBox
				options.boxFromAppendInfo = resultBox
			}
			this.eventBus.$emit('setTempRowNum', options)
			this.quitSetRows()
		},
		//手动配置情况下  横向行数增加或者减少
		horizontalResetRow(options, appendInfo, remarks) {
			if (this.tempObjTopic.length === 0) {
				this.$message.error('请选择可客观题')
				return
			}
			let handleOrigin = remarks.handleOrigin
			// 行数增多的情况
			function moreRow(interval) {
				const orderOrigin = cloneDeep(sortBy(handleOrigin, value => -Number(value[0].y)))
				let rowHeight = 50
				if (orderOrigin.length > 1) rowHeight = orderOrigin[0][0].y - orderOrigin[1][0].y
				const lastRow = cloneDeep(orderOrigin[0])
				let addBox = []
				for (let i = 1; i <= interval; i++) {
					lastRow.forEach(res => (res.y += rowHeight))
					addBox.push(lastRow)
				}
				handleOrigin = [...handleOrigin, ...addBox]
				resResult()
			}
			//行数减少的情况下
			function lessRow(nums) {
				handleOrigin.length = nums
				resResult()
			}
			//结果
			function resResult() {
				appendInfo.box = handleOrigin.flat(Infinity)
				remarks.handleOrigin = handleOrigin
				options.appendInfo = JSON.stringify(appendInfo)
				options.remarks = JSON.stringify(remarks)
			}
			if (this.nums > handleOrigin.length) {
				moreRow(this.nums - handleOrigin.length)
			} else if (this.nums < handleOrigin.length) {
				lessRow(this.nums)
			} else {
				return
			}
			this.eventBus.$emit('setTempRowNum', options)
			this.quitSetRows()
		},
		//取消按钮
		quitSetRows() {
			document.body.removeChild(this.$refs['resetRow'])
		},
		//设置value
		stepVal(val) {
			this.nums = val
		},
		// 外面对当前行数调用 传递默认值
		getOptions(val, direction) {
			this.options = val
			this.direction = direction
		},
		dragstop() {}
	}
}
</script>

<style scoped lang="less">
.wrap {
	background: white;
	box-shadow: 0 0 20px 3px #454040;
	border-radius: 10px;
}
.name {
	text-align: center;
	display: block;
	padding: 20px 0 0;
	font-size: 22px;
	box-sizing: border-box;
}
.form-style {
	width: 300px;
	height: 160px;
	padding: 30px;
	box-sizing: border-box;
}
.btn-evenly {
	display: flex;
	justify-content: center;
}
</style>
